import ArrowRight16 from '@carbon/icons-react/es/arrow--right/16';
import Information20 from '@carbon/icons-react/es/information/20';
import Link16 from '@carbon/icons-react/es/link/16';
import Unlink16 from '@carbon/icons-react/es/unlink/16';
import { Divider, Space, Typography } from 'antd';
import { isEmpty } from 'lodash';
import React, { FC } from 'react';
import { JiraConfig } from 'api/integrations/jira';
import { Button } from 'components/atoms/button';
import { InlineNotification } from 'components/atoms/inline-notification';
import { InlineNotificationType } from 'components/atoms/inline-notification/inline-notification-types';
import { useTranslation } from 'hooks/use-translation';
import { IntegrationStatusTypes } from '../../authentication-types';
import { AlertButton, Message } from '../../styles';
import { Heading } from '../styles';

const { useState } = React;
const { Text } = Typography;

type AuthenticateJira = {
  oauthUrl: string;
  reAuthUrl: string;
  onDisconnectClick: () => void;
  jiraConfig?: JiraConfig;
  loading?: boolean;
};

export const AuthenticateJira: FC<AuthenticateJira> = ({
  oauthUrl,
  jiraConfig,
  loading,
  reAuthUrl,
  onDisconnectClick,
}): JSX.Element => {
  const connectedText = useTranslation('connected');
  const disconnectText = useTranslation('disconnect');

  const authenticateTitle = useTranslation(
    'settings.integrations.jira.authenticate.title',
  );
  const authenticatedTitle = useTranslation(
    'settings.integrations.jira.authenticate.title',
  );
  const connectText = useTranslation(
    'settings.integrations.jira.authenticate.connect',
  );
  const authenticatorEmail = useTranslation(
    'settings.integrations.jira.authenticate.connected.as',
    { connector: jiraConfig?.meta.oauthAuthenticatorEmail },
  );

  const [showDisconnect, setShowDisconnect] = useState(false);

  const onMouserHandle = (status = false) => {
    setShowDisconnect(status);
  };
  const alertMessage = useTranslation('integration.alert.error.message');
  const reAuthMessage = useTranslation(
    'settings.integrations.jira.authentication.alert.button.message',
  );
  const reAuthenticate = useTranslation(
    'settings.integration.alert.button.message',
  );

  return (
    <>
      {jiraConfig ? (
        <>
          {jiraConfig.integrationStatus === IntegrationStatusTypes.Expired && (
            <InlineNotification
              msg={
                <Message>
                  <strong>{alertMessage}</strong> {reAuthMessage}
                </Message>
              }
              type={InlineNotificationType.Error}
              button={
                <AlertButton size="small" type="tertiary" href={reAuthUrl}>
                  {reAuthenticate}
                </AlertButton>
              }
              icon={<Information20 />}
            />
          )}
          <Heading>{authenticatedTitle}</Heading>
          <Space direction="vertical" size={4} align="start">
            <Button
              type="primary"
              icon={showDisconnect ? <Unlink16 /> : <Link16 />}
              iconPlacement="right"
              onClick={onDisconnectClick}
              onMouseEnter={() => onMouserHandle(true)}
              onMouseLeave={() => onMouserHandle(false)}
              danger={!!showDisconnect}
            >
              {showDisconnect ? disconnectText : connectedText}
            </Button>
            <Text>{authenticatorEmail}</Text>
          </Space>
        </>
      ) : (
        <>
          <Heading>{authenticateTitle}</Heading>
          <Button
            type="primary"
            icon={<ArrowRight16 />}
            iconPlacement="right"
            href={oauthUrl}
            disabled={isEmpty(oauthUrl)}
            loading={loading}
          >
            {connectText}
          </Button>
        </>
      )}

      <Divider />
    </>
  );
};
